<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockIn.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('stockIn.pageTitle'),
          href: '/admin/v2/stock-in'
        },
        {
          text: $t('edit'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info v-model="model" :validate="errors" class="tw-p-3 tw-rounded" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList v-model="model" :validate="errors" class="tw-p-3 tw-rounded" />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                <ts-button @click.prevent="$router.push({ name: 'stock-in-v2' })">{{
                  $t('cancel')
                }}</ts-button>
                <ts-button color="primary" :waiting="waiting" @click.prevent="onUpdate">{{ $t('update') }}</ts-button>
              </div>
            </div>
          </form>
        </ts-loading-banner>
        <!-- Purchase Type -->
        <a-modal :title="$t('purchaseOrder.createPurchaseType')" width="30%" v-model="add_new_purchase_type"
          :footer="null">
          <div class="row">
            <label class="form-col-label control-label col-md-12">{{
              $t('purchaseOrder.purchaseType')
            }}</label>
            <div class="col-md-12">
              <input v-model="purchase_type_model.purchase_type" type="text" class="form-control" />
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
              <ts-button @click.prevent="() => (add_new_purchase_type = false)">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button :waiting="waiting_new_purchase_type" @click.prevent="onSavePurchaseType" color="primary">{{
                $t('save') }}</ts-button>
            </div>
          </div>
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import ItemList from './components/item-list.vue'
import Info from './components/info.vue'
import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'stockInEdit',
  components: {
    Info,
    ItemList,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      add_new_purchase_type: false,
      waiting_new_purchase_type: false,
      model: {
        stock_in_id: null,
        location_id: null,
        invoice_no: null,
        stock_in_date: moment().format('DD-MM-YYYY'),
        po_id: null,
        vendor_id: null,
        currency_id: null,
        input_currency_id: null,
        fx_rate: 1,
        fx_rate_ratio: 1,
        purchase_type_id: null,
        credit_day: 0,
        next_payment_date: null,
        stock_in_warehouse_type: 'vendor',
        invoice_amount: null,
        remarks: null,
        product_details: [],
      },
      purchase_type_model: {
        purchase_type: null
      }
    }
  },
  computed: {
    ...mapState('stock/stockInV2', ['formViewDatas', 'edit_data']),
  },
  methods: {
    ...mapActions('stock/stockInV2', ['getFormViewModel', 'update', 'find']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
        .then(async () => {
          await this.find(this.$route.params.id).then(() => {
            this.setEditData()
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onSavePurchaseType() {
      this.waiting_new_purchase_type = true
      this.errors = new Errors()
      this.$store
        .dispatch('purchaseOrder/purchaseType/store', this.purchase_type_model)
        .then(async response => {
          this.$toasted.success(response.message)
          await this.$store.commit(
            'stock/stockIn/PUSH_NEW_PURCHASE_TYPE',
            response.data
          )
          this.model.purchase_type_id = data.purchase_type_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new_purchase_type = false
          this.add_new_purchase_type = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.model.stock_in_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-in-v2' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      this.model.stock_in_id = this.edit_data.stock_in_id
      this.model.location_id = this.edit_data.location_id
      this.model.invoice_no = this.edit_data.invoice_no
      this.model.stock_in_date = this.edit_data.stock_in_date
      this.model.po_id = this.edit_data.po_id
      this.model.vendor_id = this.edit_data.vendor_id
      this.model.currency_id = this.edit_data.currency_id
      this.model.input_currency_id = this.edit_data.input_currency_id
      this.model.fx_rate = this.edit_data.fx_rate
      this.model.fx_rate_ratio = this.edit_data.fx_rate_ratio
      this.model.purchase_type_id = this.edit_data.purchase_type_id
      this.model.credit_day = this.edit_data.credit_day
      this.model.next_payment_date = this.edit_data.next_payment_date
      this.model.stock_in_warehouse_type = this.edit_data.stock_in_warehouse_type
      this.model.invoice_amount = this.edit_data.invoice_amount
      this.model.remarks = this.edit_data.remarks

      this.edit_data.stock_in_details.forEach(el => {

        const product = this.formViewDatas['products'].find(p => p.product_id == el.product_id)

        this.model.product_details.push({
          product_id: el.product_id,
          uom_id: el.uom_id,
          uom_cat_id: el.uom_cat_id,
          qty: el.quantity,
          input_cost: el.input_cost,
          cost: el.cost,
          input_discount_rate: el.input_discount_rate,
          discount_rate: el.discount_rate,
          discount_type: el.discount_type,
          input_total_after_discount: el.input_total_after_discount,
          total_after_discount: el.total_after_discount,
          vat_rate: el.vat_rate,
          input_vat_amount: el.vat_rate,
          vat_amount: el.vat_amount,
          input_grand_total: el.input_grand_total,
          grand_total: el.grand_total,
          expiry_date: el.expiry_date,
          is_expire: product.is_expirable,
          require_imei: product.require_imei,
          product_grade: el.product_grade,
          input_currency_id: el.input_currency_id,
          currency_id: el.currency_id,
          fx_rate: el.fx_rate,
          fx_rate_ratio: el.fx_rate_ratio,
          imei_list: el.imei_list
            ? el.imei_list.split(',').map(el => el)
            : [],
          stock_quantity: el.stock_quantity
        })
      })
    },
    onVendorChange(value, opt) {
      this.model.credit_day = opt.data.props.credit_day
    },
    updateNextPaymentDate() {
      if (this.model.stock_in_date && this.model.credit_day > 0) {
        this.model.next_payment_date = moment(
          this.model.stock_in_date,
          'DD-MM-YYYY'
        )
          .add(this.model.credit_day, 'days')
          .format('DD-MM-YYYY')
      } else {
        this.model.next_payment_date = null
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockInV2/SET_EDIT_DATA', {})
    next()
  }
}
</script>
